// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Tron","topBottomGutter":"Layout_topBottomGutter__28dEC"};